import { Button, Modal } from "semantic-ui-react";
import EventCard from "./EventCard";

const EventModal = ({ event, open, close, hidden }) => {
  return (
    <Modal
      className="eventsizeModal"
      size="tiny"
      dimmer={true}
      onClose={close}
      onOpen={open}
      open={hidden}
    >
      <Modal.Content className="eventNewModal">
        <div className="eventVisitorModalButton">
          <Button floated="left" circular icon="close" onClick={close} />
        </div>
        <div>
          <div className="AthleteEventsInfoContainer common-event">
            <div className="AthleteEventsGroupContainer onlyone">
              <EventCard
                key={event.eventId}
                eyShow={true}
                id={event.eventId}
                name={event.eventName}
                startDate={
                  typeof event.eventStartDate !== "string"
                    ? event.eventStartDate.toDate().toDateString()
                    : event.eventStartDate
                }
                endDate={
                  typeof event.eventEndDate !== "string"
                    ? event.eventEndDate.toDate().toDateString()
                    : event.eventEndtDate
                }
                url={event.eventUrl}
                visitors={event.eventAttenders}
                advocate={event.eventAdvocate}
                location={event.eventLocation}
                attendant={event.attenders}
                status={event.eventStatus}
                sport={event.eventSport}
                creator={event.eventCreator}
                view="defaultView"
              />
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default EventModal;
